firebird.factory('recordingService', [
    '$rootScope',
    'socketService',
    'analyticsWrapperService',
    'helperService',
    'meetingService',
    'brandingService',
    'localizationService',
    'attendeeService',
    'subscriptionService',
    'recordingStateService',
    'userPairStateService',
    'modalHelperService',
    function (
        $rootScope,
        socketService,
        analyticsWrapperService,
        helperService,
        meetingService,
        brandingService,
        localizationService,
        attendeeService,
        subscriptionService,
        recordingStateService,
        userPairStateService,
        modalHelperService
    ) {
        const service = {
            isRecording: false,
            hasRecording: false,
            waitingForRecordingResponse: false,
            recordingAgreementAccepted: false,
            modalsAvailable: false,

            init: init,
            updateRecordingStatus: function (data) {
                const self = this;

                self.isRecording = data.isRecording;
                self.hasRecording = data.hasRecording;
                self.setIsWaitingForRecordingResponse(false);

                $rootScope.$broadcast('recording-event', {
                    isRecording: self.isRecording
                });
            },

            toggleRecording: function () {
                const self = this;
                if (self.waitingForRecordingResponse) {
                    return;
                }

                if (self.isRecording) {
                    self.stopRecording('Meeting - Recording Stop');
                    return;
                }
                if (self.hasRecording) {
                    if (self.modalsAvailable) {
                        modalHelperService.openRecordingOptionsModal();
                    } else {
                        $rootScope.$broadcast('show-modal', 'recordingOptions');
                    }
                    return;
                }

                if (!self.isRecording && !self.hasRecording) {
                    const closeButtonHtml =
                        '<button class="sweetalert-close-x" onclick="window.swal.close();" tabindex="3"><img src="img/redesign/icons/close-big.svg"></img></button>';
                    swal(
                        {
                            title: closeButtonHtml + localizationService.translate('RECORD.DIALOG.RECORD_THIS_MEETING'),
                            text:
                                '<div class="sweetalert-text-fix-size">' +
                                localizationService.translate('RECORD.DIALOG.RECORDING_WILL_BE_STORED_ON_SERVER') +
                                '</div>',
                            showCancelButton: true,
                            confirmButtonColor: brandingService.getBaseColor(),
                            confirmButtonText: localizationService.translate('RECORD.DIALOG.START_RECORDING_TEXT'),
                            cancelButtonText: localizationService.translate('COMMON.CANCEL_TEXT'),
                            closeOnConfirm: true,
                            imageUrl: 'img/redesign/modal/pop-up-pic-record.svg',
                            customClass: 'auto-size',
                            html: true
                        },
                        function (startRecording) {
                            if (startRecording) {
                                self.sendMsgToSocket('toggle-recording');
                                self.trackRecordingEvent('Meeting - Start Recording');
                                if (meetingService.hasTranscriptionEnabled()) {
                                    self.trackRecordingEvent('Meeting - Start Transcription');
                                }
                            }
                        }
                    );
                }
            },

            queryRecordingStatus: function (attendeeData) {
                this.sendMsgToSocket('query-recording-status', attendeeData, this.queryRecordingStatusCallback);
            },

            queryRecordingStatusCallback: function (data) {
                service.updateRecordingStatus(data);
            },

            sendMsgToSocket: function (msg, data, cb) {
                const msgObj = {
                    message: msg,
                    data: data || {}
                };

                if (cb) {
                    msgObj.callback = cb;
                }

                socketService.send(msgObj);
                if (msg === 'toggle-recording') {
                    this.setIsWaitingForRecordingResponse(true);
                }
            },

            append: function () {
                this.sendMsgToSocket('toggle-recording', {
                    overwrite: false
                });
                this.trackRecordingEvent('Meeting - Recording Append');
            },

            overwrite: function () {
                this.sendMsgToSocket('toggle-recording', {
                    overwrite: true
                });
                this.trackRecordingEvent('Meeting - Recording Overwrite');
            },

            trackRecordingEvent: function (eventName) {
                if (eventName && typeof eventName === 'string') {
                    analyticsWrapperService.eventTrack(eventName, {
                        category: 'Recording'
                    });
                }
            },

            stopRecording: function (reason) {
                service.sendMsgToSocket('toggle-recording');
                service.trackRecordingEvent(reason);
            },

            shouldShowRecordingNotification: shouldShowRecordingNotification,
            showRecordingNotificationForJoiningAttendee: showRecordingNotificationForJoiningAttendee,
            showRecordingNotificationForExistingAttendee: showRecordingNotificationForExistingAttendee,
            showRecordingNotification: showRecordingNotification,
            setIsWaitingForRecordingResponse: setIsWaitingForRecordingResponse
        };

        service.init();
        return service;

        ////////////////////////

        function init() {
            $rootScope.$on('recording-status', function (evt, data) {
                service.updateRecordingStatus(data);
                if (service.shouldShowRecordingNotification()) {
                    service.showRecordingNotificationForExistingAttendee();
                }
            });

            $rootScope.$on('end-wait-for-recording-response', onEndWaitForRecordingResponse);

            let rootSubscription = subscriptionService.createSubscription();
            rootSubscription.add(
                recordingStateService.waitingForRecordingResponse$.subscribe(next => {
                    service.waitingForRecordingResponse = next;
                })
            );
            rootSubscription.add(
                userPairStateService.modalsAvailable$.subscribe(next => {
                    service.modalsAvailable = next;
                })
            );
        }

        function onEndWaitForRecordingResponse(evt, data) {
            service.setIsWaitingForRecordingResponse(false);
        }

        function shouldShowRecordingNotification() {
            return (
                !meetingService.isWebinar() &&
                service.isRecording &&
                attendeeService.getIsExternal() &&
                !service.recordingAgreementAccepted
            );
        }

        /**
         * @param onSuccessfulCallback {onAcceptCallback}
         */
        function showRecordingNotificationForJoiningAttendee(onSuccessfulCallback) {
            service.showRecordingNotification(true, onSuccessfulCallback);
        }

        function showRecordingNotificationForExistingAttendee() {
            service.showRecordingNotification(false);
        }

        /**
         * @param newAttendant {boolean}
         * @param successCallback {onAcceptCallback=}
         */
        function showRecordingNotification(newAttendant, successCallback) {
            const titleTextKey = newAttendant
                ? 'HEADER.SECURITY.RECORDING_NOTIFICATION.POP_UP_TITLE'
                : 'HEADER.SECURITY.RECORDING_NOTIFICATION_CONNECTED_ATTENDEE.POP_UP_TITLE';
            const messageTextKey = newAttendant
                ? 'HEADER.SECURITY.RECORDING_NOTIFICATION.POP_UP_MESSAGE'
                : 'HEADER.SECURITY.RECORDING_NOTIFICATION_CONNECTED_ATTENDEE.POP_UP_MESSAGE';

            const swalOpts = {
                title:
                    '<div data-private class="sweetalert-text-fix-size">' +
                    localizationService.translate(titleTextKey) +
                    '</div>',
                text:
                    '<div class="sweetalert-text-fix-size">' + localizationService.translate(messageTextKey) + '</div>',
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonColor: brandingService.getBaseColor(),
                cancelButtonText: localizationService.translate('HEADER.DIALOG.LEAVE_MEETING'),
                confirmButtonText: localizationService.translate('COMMON.CONTINUE_TEXT'),
                allowOutsideClick: false,
                allowEscapeKey: false,
                html: true,
                imageUrl: 'img/redesign/modal/pop-up-pic-record.svg',
                customClass: 'recording-notification-modal auto-size',
                preserveModal: true
            };

            swal(swalOpts, function (confirmed) {
                if (confirmed) {
                    service.recordingAgreementAccepted = true;
                    const analyticsMessage = newAttendant
                        ? 'Meeting - Recording Notification Join pop-up - Continue button click'
                        : 'Meeting - Recording Notification In meeting pop-up - Continue button click';
                    analyticsWrapperService.eventTrack(analyticsMessage);
                    if (successCallback) {
                        successCallback(confirmed);
                    }
                } else {
                    const analyticsMessage = newAttendant
                        ? 'Meeting - Recording Notification Join pop-up - Leave meeting button click'
                        : 'Meeting - Recording Notification In meeting pop-up - Leave meeting button click';
                    analyticsWrapperService.eventTrack(analyticsMessage);
                    $rootScope.$broadcast('leave-meeting-without-prompt');
                }
            });
        }

        /**
         * @callback onAcceptCallback
         * @param {boolean} confirmed
         */

        function setIsWaitingForRecordingResponse(waitingForRecordingResponse) {
            recordingStateService.waitingForRecordingResponse = waitingForRecordingResponse;
        }
    }
]);
